import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4dcf552a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4dcf552a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcf552a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dcf552a')) {
      api.createRecord('4dcf552a', component.options)
    } else {
      api.reload('4dcf552a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4dcf552a&scoped=true&", function () {
      api.rerender('4dcf552a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/common-member/modules/add-label/index.vue"
export default component.exports